import { createContext, useContext } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const ReCaptchaContext = createContext();

export const ReCaptchaProvider = ({ children }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LfbHl8sAAAAAI7XVQXmvhFReCnw4iYogHuZeuUU"
      language="pl"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

const useReCaptcha = () => useContext(ReCaptchaContext);

export { useReCaptcha };
export default ReCaptchaProvider;
